"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buttonIcons = void 0;
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
exports.buttonIcons = [
    'delete',
    'refresh',
    'filter',
    'columns',
    'presets',
    'start',
    'edit',
    'eye',
    'actions',
    'copy',
    'arrow_right',
    'arrow_left',
    'arrow_down',
    'arrow_up',
    'save',
    'cross',
    'search',
    'plus',
    'gear',
];
const IconButton = ({ icon, className, onClick, disabled, buttonType, shape, color, size, loading }) => {
    const readonlyIcons = exports.buttonIcons;
    const buttonShape = shape !== null && shape !== void 0 ? shape : 'circle';
    const buttonColor = color !== null && color !== void 0 ? color : 'primary';
    const buttonSize = size !== null && size !== void 0 ? size : 32;
    const iconClasses = classnames_1.default({
        'aio-icon-button': readonlyIcons.includes(icon),
        [`icon-button-${buttonColor}`]: buttonColor,
        [`icon-button-${buttonShape}`]: buttonShape,
        [`aio-icon-button-${icon}`]: !!icon,
        'aio-icon-button-loading': loading,
        [className]: !!className,
    });
    return (React.createElement("button", { onClick: disabled ? undefined : onClick, className: iconClasses, disabled: disabled || loading, type: buttonType !== null && buttonType !== void 0 ? buttonType : 'button', style: { width: buttonSize, height: buttonSize } },
        React.createElement("span", { style: { fontSize: `${buttonSize * .1}px` } })));
};
exports.default = IconButton;
//# sourceMappingURL=IconButton.js.map